import { makeClassName } from '@siteless/util';
import { IconPropsType } from '../util/types';

let UserXIcon = ({ className, ...rest }: IconPropsType) => (
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    xmlSpace="preserve"
    {...rest}
    className={makeClassName('UserXIcon', className)}
  >
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"
    />
    <circle
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      cx="8.5"
      cy="7"
      r="4"
    />
    <line
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      x1="18"
      y1="8"
      x2="23"
      y2="13"
    />
    <line
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      x1="23"
      y1="8"
      x2="18"
      y2="13"
    />
  </svg>
);

export default UserXIcon;
